import React, { useCallback } from 'react'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/react'

import { useOpenDeviceSelector } from '../../../../Devices/components/DeviceSelector/DeviceSelector'
import { changeSelectedDevices } from '../../../../Devices/useDevices'

export const ChangeDevices = () => {
  const openDeviceSelector = useOpenDeviceSelector()

  const changeDevices = useCallback(async () => {
    const devicesSelected = await openDeviceSelector()
    changeSelectedDevices(devicesSelected)
  }, [openDeviceSelector])

  return (
    <TtTooltip
      content={intl.formatMessage({ defaultMessage: 'Change devices' })}
      placement="left"
      distance={16}
    >
      <TtButton circle onClick={changeDevices} color="secondary">
        <TtIcon library="one/webinars" name="camera-settings" />
      </TtButton>
    </TtTooltip>
  )
}
